
<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="#151515" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3419 17.2745C12.1138 17.2745 11.1182 18.27 11.1182 19.4981C11.1182 20.7263 12.1138 21.7218 13.3419 21.7218C14.57 21.7218 15.5656 20.7263 15.5656 19.4981C15.5656 18.27 14.57 17.2745 13.3419 17.2745ZM8.89453 19.4981C8.89453 17.0419 10.8857 15.0508 13.3419 15.0508C15.7981 15.0508 17.7893 17.0419 17.7893 19.4981C17.7893 21.9544 15.7981 23.9455 13.3419 23.9455C10.8857 23.9455 8.89453 21.9544 8.89453 19.4981Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.5001 3.59087C5.272 3.59087 4.27642 4.58645 4.27642 5.81456C4.27642 7.04266 5.272 8.03824 6.5001 8.03824C7.72821 8.03824 8.72379 7.04266 8.72379 5.81456C8.72379 4.58645 7.72821 3.59087 6.5001 3.59087ZM2.05273 5.81456C2.05273 3.35834 4.04389 1.36719 6.5001 1.36719C8.95632 1.36719 10.9475 3.35834 10.9475 5.81456C10.9475 8.27077 8.95632 10.2619 6.5001 10.2619C4.04389 10.2619 2.05273 8.27077 2.05273 5.81456Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.1837 3.59087C18.9556 3.59087 17.96 4.58645 17.96 5.81456C17.96 7.04266 18.9556 8.03824 20.1837 8.03824C21.4118 8.03824 22.4074 7.04266 22.4074 5.81456C22.4074 4.58645 21.4118 3.59087 20.1837 3.59087ZM15.7363 5.81456C15.7363 3.35834 17.7275 1.36719 20.1837 1.36719C22.6399 1.36719 24.6311 3.35834 24.6311 5.81456C24.6311 8.27077 22.6399 10.2619 20.1837 10.2619C17.7275 10.2619 15.7363 8.27077 15.7363 5.81456Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.59867 8.21094C7.21947 8.21094 7.72273 8.70107 7.72273 9.30567V10.4004C7.72273 10.6908 7.84116 10.9692 8.05196 11.1745C8.26276 11.3798 8.54867 11.4951 8.84679 11.4951H17.8393C18.1374 11.4951 18.4233 11.3798 18.6341 11.1745C18.8449 10.9692 18.9633 10.6908 18.9633 10.4004V9.30567C18.9633 8.70107 19.4666 8.21094 20.0874 8.21094C20.7082 8.21094 21.2114 8.70107 21.2114 9.30567V10.4004C21.2114 11.2714 20.8562 12.1068 20.2238 12.7227C19.5914 13.3386 18.7336 13.6846 17.8393 13.6846H8.84679C7.95243 13.6846 7.0947 13.3386 6.4623 12.7227C5.82989 12.1068 5.47461 11.2714 5.47461 10.4004V9.30567C5.47461 8.70107 5.97787 8.21094 6.59867 8.21094Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3427 11.6328C13.9095 11.6328 14.369 12.1229 14.369 12.7275V16.0118C14.369 16.6164 13.9095 17.1065 13.3427 17.1065C12.7759 17.1065 12.3164 16.6164 12.3164 16.0118V12.7275C12.3164 12.1229 12.7759 11.6328 13.3427 11.6328Z"
        />
    </svg>
</template>
<script>
export default {
    name: "CrmIconIcon"
}
</script>
